<script>
export default {
    name: 'SuccessResponse',
}
</script>

<template>
  <div class="status-message success">
    <svg class="icon" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
    </svg>
    <span>Payment successful! Your invoice has been paid. Thank you! You can now close this page.</span>
  </div>
</template>

<style scoped>
.status-message {
  padding: 16px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  font-size: 15px;
  line-height: 1.5;
}

.status-message.success {
  background-color: #e7f6ee;
  border: 1px solid #d1e9db;
  color: #0a3622;
}

.status-message.success .icon {
  color: #16a34a;
}

.status-message .icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Stripe/SuccessResponse.vue